import React from 'react';
import { Modal, TextInput } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export const NewStageModal = ({
  setShowModal,
  isOpen,
  onSuccess,
  stageName,
  setStageName,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      showModal={isOpen}
      subtitle={t(translations.MODALS.NEW_STAGE_SUBTITLE)}
      setShowModal={setShowModal}
      onSuccess={onSuccess}
      width="md:w-6/12 xl:w-4/12"
      title={t(translations.MODALS.NEW_STAGE_TITLE)}>
      <>
        <p className="mb-2 text-caption text-gray-300">
          {t(translations.MODALS.NEW_STAGE_NAME)}
        </p>
        <TextInput
          isFullWidth
          name="stage"
          value={stageName}
          onChange={(e) => setStageName(e.target.value)}
        />
      </>
    </Modal>
  );
};
